import React from "react";
import { Link } from 'react-router-dom'
import Title from "../Title/Title";
import BlogImg1 from '../../assets/images/blog-1.jpg'
import BlogImg2 from '../../assets/images/blog-2.jpg'
import BlogImg3 from '../../assets/images/blog-3.jpg'
import BlogImg4 from '../../assets/images/blog-4.jpg'


const Bloglist = () => {
  return (
    <>
      <section className="blog-list">
        <div className="container">
          <div className="row">
            <div className="col-full">
              <Title title="our blogs" />
              <div className="blog-grid">
                <div className="blog-card">
                  <Link to="/">
                    <img
                      src={BlogImg1}
                      alt="Clothes Retail KPIs 2021 Guide for Clothes Executives"
                      width="300"
                      className="blog-banner"
                    />
                  </Link>

                  <div className="blog-content">
                    <Link to="/">
                      <h3 className="blog-title">
                        Clothes Retail KPIs 2021 Guide for Clothes Executives.
                      </h3>
                    </Link>
                    <p className="blog-desc">Lorem ipsum dolor sit amet consectetur Lorem ipsum dolor dolor sit amet.</p>


                    <p className="blog-meta">
                      By <cite>Admin</cite> /{" "}
                      <time dateTime="2022-04-06">Apr 06, 2022</time>
                    </p>
                  </div>
                </div>
                <div className="blog-card">
                  <Link to="/">
                    <img
                      src={BlogImg2}
                      alt="Clothes Retail KPIs 2021 Guide for Clothes Executives"
                      width="300"
                      className="blog-banner"
                    />
                  </Link>

                  <div className="blog-content">
                    <Link to="/">
                      <h3 className="blog-title">
                        Clothes Retail KPIs 2021 Guide for Clothes Executives.
                      </h3>
                    </Link>
                    <p className="blog-desc">Lorem ipsum dolor sit amet consectetur Lorem ipsum dolor dolor sit amet.</p>

                    <p className="blog-meta">
                      By <cite>Admin</cite> /{" "}
                      <time dateTime="2022-04-06">Apr 06, 2022</time>
                    </p>
                  </div>
                </div>
                <div className="blog-card">
                  <Link to="/">
                    <img
                      src={BlogImg3}
                      alt="Clothes Retail KPIs 2021 Guide for Clothes Executives"
                      width="300"
                      className="blog-banner"
                    />
                  </Link>

                  <div className="blog-content">
                    <Link to="/">
                      <h3 className="blog-title">
                        Clothes Retail KPIs 2021 Guide for Clothes Executives.
                      </h3>
                    </Link>
                    <p className="blog-desc">Lorem ipsum dolor sit amet consectetur Lorem ipsum dolor dolor sit amet.</p>

                    <p className="blog-meta">
                      By <cite>Admin</cite> /{" "}
                      <time dateTime="2022-04-06">Apr 06, 2022</time>
                    </p>
                  </div>
                </div>
                <div className="blog-card">
                  <Link to="/">
                    <img
                      src={BlogImg4}
                      alt="Clothes Retail KPIs 2021 Guide for Clothes Executives"
                      width="300"
                      className="blog-banner"
                    />
                  </Link>

                  <div className="blog-content">
                    <Link to="/">
                      <h3 className="blog-title">
                        Clothes Retail KPIs 2021 Guide for Clothes Executives.
                      </h3>
                    </Link>
                    <p className="blog-desc">Lorem ipsum dolor sit amet consectetur Lorem ipsum dolor dolor sit amet.</p>

                    <p className="blog-meta">
                      By <cite>Admin</cite> /{" "}
                      <time dateTime="2022-04-06">Apr 06, 2022</time>
                    </p>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Bloglist;
